import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Authprovider } from './Context/Authcontext';
import { Provider } from 'react-redux';
import store from './store';
import { ThemeProvider } from "@material-tailwind/react";
import NoInternetConnection from './NoInternetConnection';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <NoInternetConnection>
      <ThemeProvider>
        <Provider store={store}>
          <Authprovider>
            <App />


          </Authprovider>
        </Provider>
      </ThemeProvider>
    </NoInternetConnection>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
